var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { NodeIndexOutlined } from '@ant-design/icons';
import { Button, Col, Popover, Row, Switch, Tooltip } from 'antd';
import { omit } from 'lodash';
import React, { useEffect } from 'react';
import { i18n } from '../../translations';
import { MapToolsDropdownTKeys } from '../../translations/keys';
import { useAuth, useMixpanel } from '@tenderd/track-web-utils';
export var getDefaultMapTools = function (accountId) {
    var hideDistantVehicles = false;
    var isNeom = accountId === 'SEuU5bcSn5ZO1mBpoWCr';
    if (isNeom) {
        hideDistantVehicles = true;
    }
    return {
        showGeofence: true,
        showAllGeofence: false,
        showLabels: false,
        showModelNames: false,
        showCustomIDs: false,
        showTrafic: false,
        showCluster: false,
        showDistance: false,
        hideDistantVehicles: hideDistantVehicles,
    };
};
var Maptools = function (props) {
    var account = useAuth().account;
    var mixpanel = useMixpanel();
    useEffect(function () {
        try {
            var defaultMapTools_1 = getDefaultMapTools(account.id);
            if (props.cacheSettings) {
                var mapToolsConfig = localStorage.getItem('mapToolsConfig') || '';
                var parsedMapToolsConfig = JSON.parse(mapToolsConfig);
                var newMapToolsConfig_1 = __assign({}, parsedMapToolsConfig);
                Object.keys(defaultMapTools_1).forEach(function (key) {
                    if (!newMapToolsConfig_1.hasOwnProperty(key)) {
                        newMapToolsConfig_1[key] = defaultMapTools_1[key];
                    }
                });
                props.onChange(newMapToolsConfig_1);
            }
            else {
                props.onChange(defaultMapTools_1);
            }
        }
        catch (error) {
            console.error(error);
        }
    }, [props.clusterEnabled]);
    useEffect(function () {
        if (props.value && props.cacheSettings)
            localStorage.setItem('mapToolsConfig', JSON.stringify(omit(props.value, 'showAllGeoFence')));
    }, [props.value]);
    return (React.createElement(Popover, { title: "Map Tools", content: React.createElement(MapToolsContent, __assign({}, props)), trigger: "click", placement: "bottomRight" },
        React.createElement(Button, { onClick: function () { mixpanel.track('Clicked Map tools', { extension: 'track' }); } }, "Map Tools")));
};
export default Maptools;
var MapToolsContent = function (props) {
    var onChange = function (key, value) {
        var newMapTools = __assign({}, props.value);
        if (value !== undefined) {
            newMapTools[key] = value;
        }
        else {
            newMapTools[key] = !newMapTools[key];
        }
        if (key === 'showCluster') {
            newMapTools.showLabels = false;
            newMapTools.showModelNames = false;
            newMapTools.showCustomIDs = false;
        }
        props.onChange(newMapTools);
    };
    return (React.createElement("div", { className: "map-tools-menu" },
        React.createElement(Row, { className: "map-tools-menu-item" },
            React.createElement(Col, { span: 24 },
                React.createElement(Button, { onClick: function () {
                        onChange('showDistance');
                    } },
                    React.createElement(NodeIndexOutlined, null),
                    ' ',
                    i18n.t(MapToolsDropdownTKeys.measureDistance)))),
        React.createElement(Row, { className: "map-tools-menu-item" },
            React.createElement(Col, { span: 20 },
                React.createElement("h1", null, "Show labels ")),
            React.createElement(Col, { span: 4, className: "switch" },
                React.createElement(Switch, { disabled: props.value.showCluster, checked: props.value.showLabels, onChange: function () { return onChange('showLabels'); } }))),
        React.createElement(Row, { className: "map-tools-menu-item" },
            React.createElement(Col, { span: 20 },
                React.createElement("h1", null, "Show model names ")),
            React.createElement(Col, { span: 4, className: "switch" },
                React.createElement(Tooltip, { title: !props.value.showLabels
                        ? 'To show model names, you have to enable show labels'
                        : '' },
                    React.createElement(Switch, { disabled: !props.value.showLabels, checked: props.value.showModelNames, onChange: function () { return onChange('showModelNames'); } })))),
        React.createElement(Row, { className: "map-tools-menu-item" },
            React.createElement(Col, { span: 20 },
                React.createElement("h1", null, "Show custom ID "),
                React.createElement("p", null, "This will replace the number plate")),
            React.createElement(Col, { span: 4, className: "switch" },
                React.createElement(Tooltip, { title: !props.value.showLabels
                        ? 'To show custom ID, you have to enable show labels'
                        : '' },
                    React.createElement(Switch, { disabled: !props.value.showLabels, checked: props.value.showCustomIDs, onChange: function () { return onChange('showCustomIDs'); } })))),
        React.createElement(Row, { className: "map-tools-menu-item" },
            React.createElement(Col, { span: 20 },
                React.createElement("h1", null, "Cluster Equipment "),
                React.createElement("p", null, "Disables live data and labels")),
            React.createElement(Col, { span: 4, className: "switch" },
                React.createElement(Switch, { checked: props.value.showCluster, onChange: function () {
                        onChange('showLabels', false);
                        onChange('showCluster');
                    } }))),
        React.createElement(Row, { className: "map-tools-menu-item" },
            React.createElement(Col, { span: 20 },
                React.createElement("h1", null, "Show group geofence ")),
            React.createElement(Col, { span: 4, className: "switch" },
                React.createElement(Switch, { checked: props.value.showGeofence, onChange: function () { return onChange('showGeofence'); } }))),
        React.createElement(Row, { className: "map-tools-menu-item" },
            React.createElement(Col, { span: 20 },
                React.createElement("h1", null, "Show all geofences")),
            React.createElement(Col, { span: 4, className: "switch" },
                React.createElement(Switch, { checked: props.value.showAllGeofence, onChange: function () { return onChange('showAllGeofence'); } }))),
        React.createElement(Row, { className: "map-tools-menu-item" },
            React.createElement(Col, { span: 20 },
                React.createElement("h1", null, "Show Traffic")),
            React.createElement(Col, { span: 4, className: "switch" },
                React.createElement(Switch, { checked: props.value.showTrafic, onChange: function () { return onChange('showTrafic'); } }))),
        React.createElement(Row, { className: "map-tools-menu-item" },
            React.createElement(Col, { span: 20 },
                React.createElement("h1", null, "Hide distant vehicles"),
                React.createElement("p", null, "Hides devices that are far away from the center of the geofence")),
            React.createElement(Col, { span: 4, className: "switch" },
                React.createElement(Switch, { checked: props.value.hideDistantVehicles, onChange: function () { return onChange('hideDistantVehicles'); } })))));
};
Maptools.defaultProps = {
    cacheSettings: true,
};
